import type { ReviewPage } from './review-page';

export const yelpPages: ReviewPage[] = [
  {
    label: 'California',
    children: [
      {
        label: 'Los Angeles, CA',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-pasadena',
      },
      {
        label: 'Orange County, CA',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-newport-beach-4',
      },
    ],
  },
  {
    label: 'Florida',
    children: [
      {
        label: 'Fort Myers, FL',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-cape-coral-3',
      },
    ],
  },
  {
    label: 'Tennessee',
    children: [
      {
        label: 'Clarksville, TN',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-clarksville',
      },
      {
        label: 'Nashville, TN',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-nashville',
      },
    ],
  },
  {
    label: 'Texas',
    children: [
      {
        label: 'Austin, TX',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-austin',
      },
      {
        label: 'Dallas, TX',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-plano-7',
      },
      {
        label: 'Houston, TX',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-the-woodlands',
      },
      {
        label: 'New Braunfels, TX',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-new-braunfels',
      },
      {
        label: 'San Antonio, TX',
        href: 'https://www.yelp.com/biz/marshall-reddick-real-estate-san-antonio',
      },
    ],
  },
];
